import React from "react"
import PropTypes from "prop-types"

import CityForm from "apps/core/City/CityForm"
import { reverse } from "utils/urls"

export default function CityUpdate(props) {
  return (
    <CityForm
      {...props}
      isUpdate
      actionEndpoint={`/cities/${props.match.params.id}/`}
      successUrl={reverse("cityDetail", { id: props.match.params.id })}
    />
  )
}

CityUpdate.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
